import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ReactComponent as LockIcon } from '../../assets/images/svg/clock.svg';
import themeColors from '../../assets/styles/themeColors';

const ClockStyled = styled.div`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  border-radius: 100%;
  background-color: ${themeColors.colorBackgroundPrimaryDark};
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 26px;
    fill: ${({ color }) => color || themeColors.colorTextPrimary};
  }
`;

const Clock = (props) => (
  <ClockStyled {...props}>
    <LockIcon />
  </ClockStyled>
);

Clock.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  color: PropTypes.string,
};

Clock.defaultProps = {
  w: '62px',
  h: '62px',
};

export default Clock;
